jQuery(function($){
  $('.product-item__inner .product-item__image-link').hover(
    function (){
     // 要素にマウスを載せたときの処理
     $(this).children('.product-item__image--two').addClass('active');
    },
    function () {
     // 要素からマウスをはなした
      $(this).children('.product-item__image--two').removeClass('active');
    }
  );
});